export const FORM_SET_VALUE = 'FORM_SET_VALUE'
export const FORM_SET_ERROR = 'FORM_SET_ERROR'
export const FORM_CLEAR_ERRORS = 'FORM_CLEAR_ERRORS'
export const FORM_CLEAR_ERROR = 'FORM_CLEAR_ERROR'
export const FORM_RESET_FIELD = 'FORM_RESET_FIELD'
export const FORM_RESET = 'FORM_RESET'
export const FORM_CLEAR = 'FORM_CLEAR'
export const FORM_CLEAR_FIELD = 'FORM_CLEAR_FIELD'
export const FORM_CLEAR_FIELDS = 'FORM_CLEAR_FIELDS'
